import { AdminSliceState } from 'src/core/models'

const adminState: AdminSliceState = {
  adminStatics: {
    loading: false,
    userEmail: '',
    usersPendinToBeValidated: 0,
    transactionsCount: 0,
    transactionsValue: 0
  },
  generateCertificate: {
    loading: false,
    response: null,
    error: ''
  },
  /* Massive Calculation Steps */
  massiveCalculation: {
    step: 0,
    fileKeys: [],
    excelData: [],
    fileName: '',
    isNextButtonDisabled: true,
    calculeUrl: null,
    carKeys: {
      country: null,
      distanceKlm: null,
      vehicleModel: null,
      vehicleFuel: null
    },
    planeKeys: {
      from: null,
      to: null,
      paxes: null,
      classType: null,
      roundtrip: null
    },
    parcelKeys: {
      from: null,
      to: null,
      weigth: null,
      fleetType: null
    },
    loadingPreview: false,
    preViewList: [],
    responseCalculate: {
      loading: false,
      data: [],
      errorMessage: null
    }
  },
  brokerage: {
    selectedTab: 'PURCHASE',
    baseForm: {
      purchasePriceCurrency: 'EUR',
      salePriceCurrency: 'EUR'
    }
  },
  users: {
    loading: false,
    data: [],
    filterText: null,
    filterTypeOption: 'ALL',
    filterStatusOption: 'ALL',
    filterGroupOption: 'ALL',
    validateUser: {
      loading: false,
      error: null,
      success: false,
      currencUserId: null
    },
    rejectUser: {
      loading: false,
      error: null,
      success: false,
      currencUserId: null
    }
  },
  withdrawals: {
    loading: false,
    data: [],
    filterStatus: 'pending',
    filterText: null,
    validateWithdrawal: {
      loading: false,
      success: false,
      error: null,
      currenctWithdrawal: null
    },
    cancelWithdrawal: {
      loading: false,
      success: false,
      error: null,
      currenctWithdrawal: null
    }
  },
  documents: {
    loading: false,
    data: [],
    filtered: [],
    isAllCollapse: false,
    validateCancellation: {
      loading: false,
      success: false,
      error: null,
      currentDocumentId: null
    },
    validateReceipt: {
      loading: false,
      success: false,
      error: null,
      currentDocumentId: null
    },
    validateTaxRelief: {
      loading: false,
      success: false,
      error: null,
      currentDocumentId: null
    },
    validateCarbonForwardFile: {
      loading: false,
      success: false,
      error: null,
      currentDocumentId: null
    },
    filterText: ''
  },
  transfer: {
    loading: false,
    data: [],
    filtered: [],
    validateTransfer: {
      loading: false,
      success: false,
      error: null,
      currentTransfer: null
    },
    rejectTransfer: {
      loading: false,
      success: false,
      error: null,
      currentTransfer: null
    }
  },
  deposits: {
    loading: false,
    data: []
  },
  suppliersAPICron: {
    loading: false,
    success: false,
    error: false
  }
}

export { adminState as initialState }
